import { render, staticRenderFns } from "./editor-page.vue?vue&type=template&id=ccfee992&scoped=true"
import script from "./editor-page.vue?vue&type=script&lang=js"
export * from "./editor-page.vue?vue&type=script&lang=js"
import style0 from "./editor-page.vue?vue&type=style&index=0&id=ccfee992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfee992",
  null
  
)

export default component.exports